import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { PayoutLessonVM, PayoutLessonsContext } from "@shared-kernel/application/ports/shared/shared-repository";

type Payload = PayoutLessonsContext & { payoutId: string };

export const retrieveTeacherPayoutLessons = createAsyncThunk<PayoutLessonVM[], Payload, { extra: Partial<Dependencies> }>(
  "payoutLessons/teacherRetrievePayoutLessons",
  async (payload, { extra: { sharedRepository } }) => {
    const { payoutId, ...context } = payload;
    return sharedRepository!.getPayoutLessons(payoutId, context);
  },
);
